import { render, staticRenderFns } from "./ProductionTree.vue?vue&type=template&id=f243013a&scoped=true&"
import script from "./ProductionTree.vue?vue&type=script&lang=js&"
export * from "./ProductionTree.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTree.vue?vue&type=style&index=0&id=f243013a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f243013a",
  null
  
)

export default component.exports